import React from 'react'
import Markdown from 'react-markdown'

type MarkdownContentProps = {
    content?: string
    className?: string
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({ content = '', className = '' }) => {
    return (
        <div className={`w-full text-sm leading-[1.6] text-[var(--pixorion-gray-2)] ${className}`}>
            <Markdown
                components={{
                    h1: ({ children }) => <h1 className='text-2xl font-semibold text-white mb-3'>{children}</h1>,
                    h2: ({ children }) => <h2 className='text-xl font-semibold text-white mb-3'>{children}</h2>,
                    h3: ({ children }) => <h3 className='text-lg font-semibold text-white mb-2'>{children}</h3>,
                    h4: ({ children }) => <h4 className='text-base font-semibold text-white mb-2'>{children}</h4>,
                    h5: ({ children }) => <h5 className='text-sm font-semibold text-white mb-2'>{children}</h5>,
                    h6: ({ children }) => <h6 className='text-sm font-medium text-white mb-2'>{children}</h6>,
                    p: ({ children }) => <p className='mb-2 last:mb-0'>{children}</p>,
                    ul: ({ children }) => <ul className='list-disc pl-5 my-2 space-y-1'>{children}</ul>,
                    ol: ({ children }) => <ol className='list-decimal pl-5 my-2 space-y-1'>{children}</ol>,
                    li: ({ children }) => <li>{children}</li>,
                    a: ({ children, href }) => (
                        <a
                            href={href}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='text-[var(--pixorion-light-violet)] underline break-words'
                        >
                            {children}
                        </a>
                    ),
                    blockquote: ({ children }) => (
                        <blockquote className='border-l-2 border-[rgba(255,255,255,0.2)] pl-3 italic my-2'>
                            {children}
                        </blockquote>
                    ),
                    hr: () => <hr className='my-3 border-[rgba(255,255,255,0.12)]' />,
                    code: ({ children }) => (
                        <code className='px-1 py-[2px] rounded bg-[rgba(255,255,255,0.08)] text-[#e6d8ff]'>
                            {children}
                        </code>
                    ),
                    pre: ({ children }) => (
                        <pre className='my-2 p-3 rounded-[10px] bg-[rgba(255,255,255,0.06)] overflow-x-auto'>
                            {children}
                        </pre>
                    ),
                    table: ({ children }) => (
                        <div className='my-2 overflow-x-auto'>
                            <table className='w-full border-collapse text-left'>{children}</table>
                        </div>
                    ),
                    thead: ({ children }) => <thead className='bg-[rgba(255,255,255,0.06)]'>{children}</thead>,
                    tbody: ({ children }) => <tbody>{children}</tbody>,
                    tr: ({ children }) => <tr className='border-b border-[rgba(255,255,255,0.08)]'>{children}</tr>,
                    th: ({ children }) => <th className='px-3 py-2 font-medium text-white'>{children}</th>,
                    td: ({ children }) => <td className='px-3 py-2 align-top'>{children}</td>,
                    strong: ({ children }) => <strong className='font-semibold text-white'>{children}</strong>,
                    em: ({ children }) => <em className='italic'>{children}</em>,
                }}
            >
                {content}
            </Markdown>
        </div>
    )
}
